define(['exports', '../../i18n', 'react'], function (exports, _i18n, _react) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _i18n2 = _interopRequireDefault(_i18n);

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var PasswordCriteria = function PasswordCriteria(props) {
    var style = { backgroundColor: '#FAFAFA' };
    return _react2.default.createElement(
      'div',
      { className: 'p2 h6', style: style },
      _react2.default.createElement(
        'div',
        { className: 'pt1' },
        _i18n2.default.t('dk-ui-lib.profile.changePassword.passwordCriteria.line-1')
      ),
      _react2.default.createElement(
        'div',
        { className: 'pt1' },
        _i18n2.default.t('dk-ui-lib.profile.changePassword.passwordCriteria.min-max_characters')
      ),
      _react2.default.createElement(
        'div',
        { className: 'pt1' },
        _i18n2.default.t('dk-ui-lib.profile.changePassword.passwordCriteria.letter')
      ),
      _react2.default.createElement(
        'div',
        { className: 'pt1' },
        _i18n2.default.t('dk-ui-lib.profile.changePassword.passwordCriteria.number')
      ),
      _react2.default.createElement(
        'div',
        { className: 'pt1' },
        _i18n2.default.t('dk-ui-lib.profile.changePassword.passwordCriteria.special_character')
      )
    );
  };

  exports.default = PasswordCriteria;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/common/PasswordCriteria.js
// module id = 180
// module chunks = 0